import React from 'react'

import './subscribe.scss'
import 'simple-react-slider/index.css'

const Subscribe = () => (
  <section
    className={'subscribe'}
  >
	  <div class="social-section">
	  	<h2>Get a glimpse into McKinsey</h2>

		  <div class="subscribe-section mobile">
			<button
				className="btn btn-primary btn-fill subscribe-cta"
				onClick={event =>
					window.location = 'https://www.mckinsey.com/careers/meet-our-people/careers-blog/custom-subscribe-to-our-careers-blog'
				}
				>
				Subscribe to our Careers Blog
			</button>
		</div>
		<div class="social-media-links">
			<ul>
				<li><a className="icon social-linkedin" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/mckinsey">LinkedIn</a></li>
				<li><a className="icon social-instagram" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/mckinseyco/?hl=en">Instagram</a></li>
				<li><a className="icon social-facebook" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/reallifeatmckinsey">Facebook</a></li>
			</ul>
		</div>
	  </div>

	  <div class="subscribe-section">
	  	<button
			className="btn btn-primary btn-fill subscribe-cta"
			onClick={event =>
				window.location = 'https://www.mckinsey.com/careers/meet-our-people/careers-blog/custom-subscribe-to-our-careers-blog'
			}
			>
			Subscribe to our Careers Blog
		</button>
	  </div>

  </section>
)

export default Subscribe
